import { render, staticRenderFns } from "./TeamScoreViewer.vue?vue&type=template&id=4b455558&scoped=true"
import script from "./TeamScoreViewer.vue?vue&type=script&lang=js"
export * from "./TeamScoreViewer.vue?vue&type=script&lang=js"
import style0 from "./TeamScoreViewer.vue?vue&type=style&index=0&id=4b455558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b455558",
  null
  
)

export default component.exports